import FilterDialog from './Dialog'
import { useSelector } from 'react-redux'
import FilterButton from '../../../../../filter/FilterButton'

const FilterButtonUsersClass = ({ type }) => {
  const open = useSelector(state => state?.filter?.usersClass?.open || false)

  return (
    <>
      <FilterButton 
        module='usersClass' 
        keysFilter={['yearLevelId', 'rolesId', 'roles', 'userIds']} 
      />
      { open &&
        <FilterDialog type={type} />
      }
    </>
  )
}
export default FilterButtonUsersClass